module.exports = __webpack_public_path__ + "static/targets-5df00b6ee2d705bc6d2824b0527b913c.png";